// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Ukubq","label":"styles_label__o_jNj","icon":"styles_icon__E68A3"};